import { motion } from "framer-motion";

export function Example() {
  return (
    <div
      style={{
        width: 400,
        height: 400,
        position: "relative"
      }}
    >
      <motion.div
        style={{
          width: 120,
          height: 120,
          borderRadius: 25,
          backgroundColor: "#fd3",
          position: "absolute",
          left: 40,
          top: 40
        }}
        animate={{
          x: [0, 200, 200, 0, 0],
          y: [0, 0, 200, 200, 0],
          rotate: -360,
          backgroundColor: ["#fd3", "#60f", "#fd3"]
        }}
        transition={{ duration: 4, ease: "linear" }}
      />
    </div>
  );
}
